import { apiGateway } from "@/shared/apiGateway";

const getClientListing = context => {
  return apiGateway
    .apiGatewayGET("api/portfolio/clients")
    .then(data => {
      return context.commit("set_client_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Clients"], {
        root: true
      });
    });
};

const getClient = (context, clientId) => {
  return apiGateway
    .apiGatewayGET("api/portfolio/clients/" + clientId)
    .then(data => {
      context.commit("set_client_contacts_listing", data.contacts);
      delete data.clientContacts;
      context.commit("set_site_listing", data.sites);
      delete data.sites;
      context.commit("set_client", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Client"], {
        root: true
      });
    });
};

const getSite = (context, siteId) => {
  return apiGateway
    .apiGatewayGET("api/portfolio/sites/" + siteId)
    .then(data => {
      context.commit("set_building_listing", data.buildings);
      delete data.buildings;
      context.commit("set_site", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Site"], {
        root: true
      });
    });
};

const getBuilding = (context, buildingId) => {
  return apiGateway
    .apiGatewayGET("api/portfolio/buildings/" + buildingId)
    .then(data => {
      context.commit("set_plant_listing", data.plants);
      delete data.plants;
      context.commit("set_building", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Building"], {
        root: true
      });
    });
};

const getPlant = (context, plantId) => {
  return apiGateway
    .apiGatewayGET("api/portfolio/plant/" + plantId)
    .then(data => {
      context.commit("set_plant", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Plant"], {
        root: true
      });
    });
};

const getContractorRegionDropdownOptions = context => {
  return apiGateway
    .apiGatewayGET("api/portfolio/contractorRegions")
    .then(data => {
      return context.commit("set_contractor_region_dropdown_options", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Contrator Regions"],
        {
          root: true
        }
      );
    });
};

export default {
  getClientListing,
  getClient,
  getContractorRegionDropdownOptions,
  getSite,
  getBuilding,
  getPlant
};
